import { useEffect, useState } from "react";

/** Mesmo corte do breakpoint `md` do Tailwind (768px). */
const MOBILE_QUERY = "(max-width: 767px)";

export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mql = window.matchMedia(MOBILE_QUERY);
        const apply = () => setIsMobile(mql.matches);

        apply();
        mql.addEventListener("change", apply);
        return () => mql.removeEventListener("change", apply);
    }, []);

    return isMobile;
}
